
import React from 'react';
import { ShippingMethodType } from '../../../state/CartContext';

interface CartShippingCalculatorProps {
    calcZip: string;
    setCalcZip: (zip: string) => void;
    calculateShipping: (zip: string) => void;
    availableMethods: {id: ShippingMethodType, name: string, price: number, eta: string}[];
    shippingMethod: ShippingMethodType;
    handleMethodSelect: (method: ShippingMethodType) => void;
}

export const CartShippingCalculator = ({
    calcZip,
    setCalcZip,
    calculateShipping,
    availableMethods,
    shippingMethod,
    handleMethodSelect
}: CartShippingCalculatorProps) => {
    return (
        <div className="border-b border-black/5 dark:border-white/10 pb-4">
            <h3 className="font-bold text-text-main dark:text-white mb-2 flex items-center gap-2">
                <span className="material-symbols-outlined text-primary">local_shipping</span>
                Calcular Envío
            </h3>
            
            <div className="flex gap-2 mb-3">
                <input 
                    type="number" 
                    placeholder="Código Postal (ej: 4000)"
                    className="flex-1 bg-black/5 dark:bg-black/20 border border-transparent focus:bg-white dark:focus:bg-black/20 focus:border-primary border-gray-200 dark:border-white/10 rounded-lg px-3 py-2 text-sm outline-none text-text-main dark:text-white font-mono transition-all"
                    value={calcZip}
                    onChange={(e) => setCalcZip(e.target.value)}
                />
                <button 
                    onClick={() => calculateShipping(calcZip)}
                    className="bg-text-main dark:bg-white text-white dark:text-black font-bold text-xs px-4 rounded-lg hover:opacity-90"
                >
                    Calcular
                </button>
            </div>

            {availableMethods.length > 0 && (
                <div className="space-y-2 animate-slide-up">
                    {availableMethods.map(method => (
                        <label key={method.id} className={`flex items-center justify-between p-3 rounded-lg border cursor-pointer transition-all ${shippingMethod === method.id ? 'border-primary bg-primary/5' : 'border-gray-200 dark:border-white/10 hover:border-gray-400'}`}>
                            <div className="flex items-center gap-3">
                                <input 
                                    type="radio" 
                                    name="shipping" 
                                    checked={shippingMethod === method.id} 
                                    onChange={() => handleMethodSelect(method.id)}
                                    className="text-primary focus:ring-primary bg-transparent border-gray-400"
                                />
                                <div>
                                    <p className="text-sm font-bold text-text-main dark:text-white">{method.name}</p>
                                    <p className="text-[10px] text-text-secondary dark:text-gray-400">Llega: {method.eta}</p>
                                </div>
                            </div>
                            <span className="font-bold text-sm text-primary">
                                {method.price === 0 ? 'GRATIS' : `$ ${method.price.toLocaleString()}`}
                            </span>
                        </label>
                    ))}
                </div>
            )}
        </div>
    );
};
